import { animated, useSpring } from '@react-spring/web';
import React from 'react';
import { FlexboxColumn } from '../action/Flexbox';

const UserPod = () => {
  const springProps = useSpring({
    from: { transform: 'translateX(80%)', opacity: 0 },
    to: { transform: 'translateX(0)', opacity: 1 },
    config: { tension: 200, friction: 30 },
  });

  return (
    <animated.div className='identity_wrapper__animation' style={springProps}>
      <FlexboxColumn className='userpod_container' gap='2rem'>
        <FlexboxColumn className='identity_wrapper__mercleLogo'>
          <svg width='33' height='38' viewBox='0 0 33 38' fill='none' xmlns='http://www.w3.org/2000/svg'>
            <path d='M23.0798 0.822266V16.4451H13.3118V0.822266H23.0798Z' fill='white' />
            <path d='M32.4541 8.15923V18.4777H0.457031V8.15923H32.4541Z' fill='white' />
            <path d='M18.3922 15.9751C26.6502 19.4748 32.457 27.6597 32.457 37.1787H22.1385C22.1385 32.1714 19.2237 27.831 15.0022 25.7636' fill='white' />
            <path d='M23.4743 14.16H13.1558C13.1558 21.1616 7.45863 26.8588 0.457031 26.8588V37.1774C13.1467 37.1774 23.4721 26.8542 23.4721 14.1623L23.4743 14.16Z' fill='white' />
          </svg>
        </FlexboxColumn>
        <p>COMING SOON</p>

        {/* <div className='planet_container'>
          <div className='user_grade'>A</div>
          <RotatingSphere />
        </div> */}
        {/* <p>Your identity strength has unmatched authenticity – almost impossible to fake</p> */}
        {/* <PodProgressBar percent={80} colorCode={'#658CFF'} /> */}
      </FlexboxColumn>
    </animated.div>
  );
};

export default UserPod;
